import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ca08d75e&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=ca08d75e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports